export const EntityConfiguration = {
    FlyoutDefinition: "Entity Flyout Definition",
    RelationshipDefinition: "Entity Relationship Definition"
};
